import React, { useEffect, useState, Fragment } from "react";
import {
  Card,
  Layout,
  Row,
  Col,
  Button,
  Table,
  message,
  Select,
  Tag,
  DatePicker,
} from "antd";

import { SearchOutlined } from "@ant-design/icons";
import "./SPTraceability.less";
import { Redirect } from "react-router-dom";
import { url } from "../../config/global";
import Axios from "axios";
import moment from "moment";

const { Content } = Layout;

const { RangePicker } = DatePicker;

const SPTraceability = () => {
  const [loading, setLoading] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);

  const [disableExport, setDisableExport] = useState(true);

  const [listDn, setListDn] = useState([]);
  const [selectedLabelDn, setSelectedLabelDn] = useState("");
  const [listSj, setListSj] = useState([]);
  const [selectedLabelSj, setSelectedLabelSj] = useState("");
  const [rangeDate, setRangeDate] = useState([null, null]);

  const [dataSourceOut, setDataSourceOut] = useState([]);
  const [dataSourceOutDetail, setDataSourceOutDetail] = useState([]);

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [expendCell, setExpendCell] = useState("");

  const columns = [
    {
      title: "DN NO",
      dataIndex: "dn_no",
      sorter: true,
    },
    {
      title: "Surat Jalan",
      dataIndex: "number",
      sorter: true,
    },
    {
      title: "No PO",
      dataIndex: "po_number",
      sorter: true,
    },
    {
      title: "Supplier",
      dataIndex: "supplier_name",
      sorter: true,
    },
    {
      title: "No Kendaraan",
      dataIndex: "vehicle_number",
      sorter: true,
    },
    {
      title: "Tanggal Outgoing",
      dataIndex: "created_at",
      render: (created_at) => moment(created_at).format("YYYY-MM-DD"),
      sorter: true,
    },
    {
      title: "Status",
      dataIndex: "status_receiving",
      render: (status_receiving) => {
        const isCompleted = status_receiving === "completed";
        return (
          <Tag color={isCompleted ? "green" : "red"}>
            {isCompleted ? "Completed" : "Incomplete"}
          </Tag>
        );
      },
      sorter: true,
    },
  ];

  useEffect(() => {
    getDn();
    getSj();
    getDataOutgoing();
  }, []);

  useEffect(() => {
    if (expendCell) {
      getDataOutgoingDetails(expendCell);
    }
  }, [expendCell]);

  useEffect(() => {
    setExpandedRowKeys([]);
  }, [dataSourceOut]);

  useEffect(() => {
    const isDateFilled =
      rangeDate && rangeDate.length === 2 && rangeDate[0] && rangeDate[1];
    const isDnFilled = !!selectedLabelDn;
    setDisableExport(!(isDateFilled || isDnFilled));
  }, [rangeDate, selectedLabelDn]);

  const handleRangeChange = (dates) => {
    setRangeDate(dates);
    // console.log(dates[0].format("YYYY-MM-DD"));
    // console.log(dates[1].format("YYYY-MM-DD"));
  };

  const handleChangeDn = (value, option) => {
    if (option) {
      setSelectedLabelDn(option.label);
    } else {
      setSelectedLabelDn(null);
    }
  };

  const handleChangeSj = (value, option) => {
    if (option) {
      setSelectedLabelSj(option.label);
    } else {
      setSelectedLabelSj(null);
    }
  };

  const expandedRowRender = (record, index) => {
    const columnsDetails = [
      {
        title: "Item Number",
        dataIndex: "item_number",
        key: "item_number",
        width: 200,
      },
      {
        title: "Standard Pack",
        dataIndex: "qty_kanban",
        key: "qty_kanban",
        width: 50,
      },
      {
        title: "Delivery Qty",
        dataIndex: "qty_delivery",
        key: "qty_delivery",
        width: 50,
      },
      {
        title: "Received Qty",
        dataIndex: "thr_receive_qty",
        key: "thr_receive_qty",
        width: 50,
        render: (_, record) => record.receive?.thr_receive_qty ?? "-",
      },
      {
        title: "Unit",
        dataIndex: "unit_of_measure",
        key: "unit_of_measure",
        width: 30,
      },
      {
        title: "Keterangan",
        dataIndex: "receive_notes",
        key: "receive_notes",
        width: 200,
      },
      {
        title: "Tanggal Receive",
        dataIndex: "thr_receive_date",
        key: "thr_receive_date",
        render: (_, record) =>
          record.receive?.thr_receive_date
            ? moment(record.receive.thr_receive_date).format("YYYY-MM-DD")
            : "-",
        sorter: true,
        width: 100,
      },
      {
        title: "Receive By",
        dataIndex: "thr_receive_byname",
        key: "thr_receive_byname",
        width: 150,
        render: (_, record) => record.receive?.thr_receive_byname ?? "-",
      },
      {
        title: "Status Receive",
        dataIndex: "status_receiving",
        width: 100,
        render: (status_receiving) => {
          const isCompleted = status_receiving === "completed";
          return (
            <Tag color={isCompleted ? "green" : "red"}>
              {isCompleted ? "Received" : "Pending"}
            </Tag>
          );
        },
        sorter: true,
      },
    ];

    return (
      <Table
        columns={columnsDetails}
        dataSource={dataSourceOutDetail}
        rowKey={(data) => data._id}
        pagination={false}
        size="small"
        loading={loadingDetail}
      />
    );
  };

  const handleClickDetails = (data) => {
    const index = data[data.length - 1];

    setExpandedRowKeys([index]);
    if (index) {
      setExpendCell(index);
      getDataOutgoingDetails(index);
    }
  };

  const exportExcel = async () => {
    setLoadingExport(true);
    try {
      const response = await Axios.get(`${url}/supplier_receive_do/export`, {
        params: {
          dn_no: selectedLabelDn,
          sj_no: selectedLabelSj,
          start_date:
            rangeDate && rangeDate[0] ? rangeDate[0].format("YYYY-MM-DD") : "",
          end_date:
            rangeDate && rangeDate[1] ? rangeDate[1].format("YYYY-MM-DD") : "",
        },
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const urls = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );

      const a = document.createElement("a");
      a.href = urls;
      a.download = "Receive DO Report.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      setLoadingExport(false);
    } catch (error) {
      message.error("Gagal export: " + error);
      setLoadingExport(false);
    }
  };

  const getDn = () => {
    setLoading(true);
    Axios.get(`${url}/listnodr/report`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        if (res.data.status) {
          const respon = res.data.data.map((item) => ({
            value: item._id,
            label: item.dn_no,
          }));
          setListDn(respon);
        }
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getSj = () => {
    setLoading(true);
    Axios.get(`${url}/listsj/report`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        if (res.data.status) {
          const respon = res.data.data.map((item) => ({
            value: item._id,
            label: item.number,
          }));
          setListSj(respon);
        }
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getDataOutgoing = () => {
    setLoading(true);
    setDataSourceOut([]);
    setDataSourceOutDetail([]);
    Axios.get(`${url}/supplier_receive_do`, {
      params: {
        for: "report",
        dn_no: selectedLabelDn,
        sj_no: selectedLabelSj,
        start_date:
          rangeDate && rangeDate[0] ? rangeDate[0].format("YYYY-MM-DD") : "",
        end_date:
          rangeDate && rangeDate[1] ? rangeDate[1].format("YYYY-MM-DD") : "",
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        setDataSourceOut(res.data);
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getDataOutgoingDetails = (dn_id = expendCell) => {
    setLoadingDetail(true);
    setDataSourceOutDetail([]);
    Axios.get(`${url}/supplier_receive_do/details/${dn_id}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        if (res.data.status) {
          setDataSourceOutDetail(res.data.data);
        }
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
        } else {
          message.error("Backend not yet Started");
        }
      })
      .finally(() => {
        setLoadingDetail(false);
      });
  };

  if (!sessionStorage.getItem("token")) {
    return <Redirect to="/login" />;
  }

  return (
    <Fragment>
      <Row>
        <Col xs={24}>
          <Card
            type="inner"
            title="Receive History"
            extra={moment(new Date()).format("DD MMMM YYYY")}
          ></Card>
        </Col>
      </Row>

      <Content className="content">
        <Row>
          <Col xs={24}>
            <Card className="body-data">
              <Row gutter={[10, 20]} justify="space-between">
                <Col
                  xs={24}
                  md={12}
                  lg={8}
                  style={{ display: "flex", justifyContent: "flex-start" }}
                >
                  <Button
                    loading={loadingExport}
                    onClick={exportExcel}
                    type="primary"
                  >
                    Export
                  </Button>
                </Col>

                <Col span={24}>
                  <div
                    style={{ display: "flex", gap: 10, alignItems: "center" }}
                  >
                    <Select
                      showSearch
                      style={{ width: "100%", maxWidth: 300 }}
                      placeholder="Search DN No"
                      onChange={handleChangeDn}
                      optionFilterProp="label"
                      filterSort={(a, b) =>
                        (a?.label ?? "")
                          .toLowerCase()
                          .localeCompare((b?.label ?? "").toLowerCase())
                      }
                      options={listDn}
                      allowClear
                    />
                    <Select
                      showSearch
                      style={{ width: "100%", maxWidth: 300 }}
                      placeholder="Search Surat Jalan"
                      onChange={handleChangeSj}
                      optionFilterProp="label"
                      filterSort={(a, b) =>
                        (a?.label ?? "")
                          .toLowerCase()
                          .localeCompare((b?.label ?? "").toLowerCase())
                      }
                      options={listSj}
                      allowClear
                    />
                    <RangePicker
                      value={rangeDate}
                      onChange={handleRangeChange}
                      format="YYYY-MM-DD"
                      style={{ width: "100%", maxWidth: 280 }}
                    />
                    <Button
                      type="primary"
                      icon={<SearchOutlined />}
                      onClick={() => getDataOutgoing()}
                    />
                  </div>
                </Col>

                <Col xs={24}>
                  <Table
                    scroll={{ x: 1300 }}
                    loading={loading}
                    rowClassName="editable-row"
                    bordered
                    dataSource={dataSourceOut.data}
                    rowKey={(data) => data._id}
                    columns={columns}
                    expandable={{
                      expandedRowRender: expandedRowRender,
                      expandedRowKeys: expandedRowKeys,
                      onExpandedRowsChange: (data) => handleClickDetails(data),
                    }}
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Content>
    </Fragment>
  );
};

export default SPTraceability;
